var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1280",
    "data-name": "Rectangle 1280",
    width: 24,
    height: 24,
    transform: "translate(276 181)",
    fill: "#136ad0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5761",
    "data-name": "Group 5761",
    transform: "translate(-276 -181)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5127",
    "data-name": "Path 5127",
    d: "M300,185.5a1,1,0,0,1-2,0,2.592,2.592,0,0,0-2.785-2.5,1,1,0,0,1,0-2A4.6,4.6,0,0,1,300,185.5Z",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M278,185.5a2.592,2.592,0,0,1,2.785-2.5,1,1,0,0,0,0-2A4.6,4.6,0,0,0,276,185.5a1,1,0,0,0,2,0Z",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M296.319,201.176A10.98,10.98,0,0,0,289,183.051V182a1,1,0,0,0-2,0v1.051a10.98,10.98,0,0,0-7.319,18.125A3.023,3.023,0,0,0,278,204a1,1,0,0,0,2,0,1.2,1.2,0,0,1,1.11-1.229.928.928,0,0,0,.2-.062,10.924,10.924,0,0,0,13.39,0,1.093,1.093,0,0,0,.182.064A1.2,1.2,0,0,1,296,204a1,1,0,0,0,2,0,3.023,3.023,0,0,0-1.681-2.824Zm-4.612-4.469a1,1,0,0,1-1.414,0l-3-3A1,1,0,0,1,287,193v-5a1,1,0,0,1,2,0v4.586l2.707,2.707a1,1,0,0,1,0,1.414Z",
    fill: "#136ad0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.c58d9cee8683574692f20f21eda8e543.svg";
export { ForwardRef as ReactComponent };